module.exports = __webpack_public_path__ + "img/relationship.a7e6006d.svg";